import React, { useEffect, useState, useRef } from 'react';
import {
  get_shift,
  bp_machine_data,
  get_employee,
  add_machine_shift,
  get_machine_shift,
} from '../../../utils/api';
import { toast } from 'react-toastify';
import { Modal } from 'antd';
import HostedCard from '@/components/HostedCard';
import DataTable from '@/components/DataTable';
import PageHeader, { EmptyState } from '@/components/PageHeader';
import { useTranslation } from 'react-i18next';
import Icons from '@/components/third-party/Icons';

function Shift({ isEmbedded = false }) {
  const inputRef = useRef(null);
  const [machine_shift_details, set_machine_shift_details] = useState([]);
  const [shift_data, set_shift_data] = useState([]);
  const [machine_data, set_machine_data] = useState([]);
  const [employee_data, set_employee_data] = useState([]);
  const [shift_submit_data, set_shift_submit_data] = useState([]);
  const { t } = useTranslation();
  const [shift_obj, set_shift_obj] = useState({
    shift: '',
    shift_id: '',
    machine: '',
    machine_id: '',
    employee_names: [],
    employee: [],
  });
  const machine_shift_columns = [
    {
      dataIndex: 'shift',
      title: 'Shift',
      key: 'shift',
      width: '8%',
    },
    // {
    //   dataIndex: "machine",
    //   title: "Machine",
    //   key: "machine",
    //   width: "8%",
    // },
    {
      dataIndex: 'employee_names',
      title: 'Employees',
      key: 'employee',
      width: '8%',
      render: (employee_names) => employee_names?.join(', '),
    },
  ]?.filter(Boolean);

  //####################### Handle Api's######################################################

  const get_all_inventory = async () => {
    try {
      await get_shift(success_get_shift);
      await bp_machine_data(success_machine_list_get);
      await get_employee(success_set_employee_list);
      await get_machine_shift(success_get_machine_shift);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const success_get_shift = (res) => {
    set_shift_data(res?.data?.data);
  };
  const success_machine_list_get = (res) => {
    set_machine_data(res?.data?.data);
  };
  const success_set_employee_list = (res) => {
    set_employee_data(res?.data?.data);
  };
  const success_get_machine_shift = (res) => {
    set_machine_shift_details(res?.data?.data);
  };

  //Add inventory
  const submit_shift = async () => {
    try {
      await add_machine_shift({ data_flow: shift_submit_data }, success_add_shift);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const success_add_shift = (res) => {
    if (res.status === 'failed') {
      toast.warning(res.message);
    } else {
      set_shift_submit_data([]);
      if (inputRef.current) {
        inputRef.current.value = '';
      }
      if (res?.existing?.length > 0) {
        error(res?.existing);
      }
      get_machine_shift(success_get_machine_shift);
      toast.success('Users shift added successfully');
    }
  };

  const reset_function = () => {
    set_shift_obj({
      shift: '',
      shift_id: '',
      machine: '',
      machine_id: '',
      employee_names: [],
      employee: [],
    });
  };

  const error = (exists_data) => {
    Modal.error({
      title: 'Error Message',
      content: (
        <DataTable
          bordered
          height={null}
          columns={[
            {
              dataIndex: 'name',
              align: 'center',
              title: 'Name',
            },
            {
              dataIndex: 'msg',
              title: 'Error Message',
            },
          ]}
          pagination={{ pageSize: 10 }}
          data={exists_data}
        />
      ),
      width: '40%',
      okText: 'Close',
    });
  };

  useEffect(() => {
    get_all_inventory();
  }, []);

  return (
    <HostedCard
      hosted={isEmbedded}
      title={
        <PageHeader
          compact
          icon={<Icons.Clock size={22} />}
          title={t('Shift Details')}
          description="Employees assigned to each shift."
        />
      }
    >
      {/* `get_machine_shift` / `add_machine_shift` are not routed on this backend (404);
          the api helper swallows the error, so the list only renders once data arrives. */}
      {!(machine_shift_details?.length > 0) ? (
        <EmptyState
          variant="unavailable"
          title="Machine shift assignment is not available"
          description="The machine-shift endpoint is not enabled on this server. Shift definitions are managed under Configurations → Shift Management."
        />
      ) : (
      <DataTable
        tableKey="shiftDetailsTable"
        searchable
        searchKeys={['shift', 'employees']}
        columnConfig
        showCount={false}
        data={machine_shift_details}
        rowKey={(r) => r.id ?? r.shift}
        height={null}
        columns={[
          {
            dataIndex: 'shift',
            title: 'Shift',
            key: 'shift',
            width: 300,
          },
          // {
          //   dataIndex: "machine",
          //   title: "Machine",
          //   key: "machine",
          //   align: "center",
          //   width: "30%",
          // },
          {
            dataIndex: 'employees',
            title: 'Employees',
            key: 'employees',
            width: 480,
            render: (employees) => employees?.join(', '),
          },
        ]?.filter(Boolean)}
        bordered
        scrollX="max-content"
      />
      )}
    </HostedCard>
  );
}

export default Shift;
